import { useEffect, useState } from "react";
import { Menu, X, MapPin } from "lucide-react";
import { track } from "@/lib/analytics";

const LINKS = [
    ["Producto", "#producto"],
    ["Tecnología", "#tecnologia"],
    ["FDA", "#fda"],
    ["Cómo funciona", "#como-funciona"],
    ["Beneficios", "#beneficios"],
    ["Chile", "#chile"],
    ["Contacto", "#contacto"],
];

export function Wordmark({ light = false }) {
    return (
        <span className={`font-display font-extrabold text-xl tracking-tight ${light ? "text-white" : "text-[#0A192F]"}`}>
            LYHER<span className="text-[#57A632]">®</span>
            <span className="ml-1 inline-block h-1.5 w-1.5 rounded-full bg-[#F97316] align-super" />
        </span>
    );
}

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 40);
        fn();
        window.addEventListener("scroll", fn, { passive: true });
        return () => window.removeEventListener("scroll", fn);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow] duration-500 ${
                scrolled || open
                    ? "bg-white/80 shadow-[0_1px_0_rgba(10,25,47,0.07)] backdrop-blur-xl"
                    : "bg-transparent"
            }`}
        >
            <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:h-20 lg:px-10">
                <a href="#inicio" data-testid="navbar-logo" aria-label="LYHER inicio">
                    <Wordmark />
                </a>
                <div className="hidden items-center gap-7 lg:flex">
                    {LINKS.map(([label, href]) => (
                        <a
                            key={href}
                            href={href}
                            data-testid={`nav-link-${label.toLowerCase().replace(/\s/g, "-").replace("ó", "o")}`}
                            className="text-sm font-semibold text-[#0A192F]/70 transition-colors duration-300 hover:text-[#059669]"
                        >
                            {label}
                        </a>
                    ))}
                </div>
                <div className="flex items-center gap-3">
                    <a
                        href="#chile"
                        data-testid="navbar-cta-chile"
                        onClick={() => track("click_find_chile", { cta_location: "navbar", destination: "chile_section" })}
                        className="hidden items-center gap-2 rounded-full bg-[#0A192F] px-5 py-2.5 text-xs font-bold tracking-wider text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#059669] sm:inline-flex"
                    >
                        <MapPin size={14} />
                        ENCONTRAR EN CHILE
                    </a>
                    <button
                        data-testid="navbar-menu-toggle"
                        aria-label="Abrir menú"
                        onClick={() => setOpen(!open)}
                        className="rounded-full p-2 text-[#0A192F] lg:hidden"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </nav>
            {open && (
                <div data-testid="navbar-mobile-menu" className="border-t border-slate-100 bg-white/95 backdrop-blur-xl lg:hidden">
                    <div className="flex flex-col gap-1 px-6 py-4">
                        {LINKS.map(([label, href]) => (
                            <a
                                key={href}
                                href={href}
                                onClick={() => setOpen(false)}
                                className="rounded-lg px-3 py-3 text-base font-semibold text-[#0A192F] transition-colors duration-200 hover:bg-slate-50 hover:text-[#059669]"
                            >
                                {label}
                            </a>
                        ))}
                        <a
                            href="#chile"
                            onClick={() => {
                                setOpen(false);
                                track("click_find_chile", { cta_location: "navbar_mobile", destination: "chile_section" });
                            }}
                            data-testid="navbar-mobile-cta"
                            className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#0A192F] px-5 py-3 text-sm font-bold text-white"
                        >
                            <MapPin size={15} />
                            ENCONTRAR EN CHILE
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
